export default __webpack_public_path__ + "static/media/ols_pattern_r.a9508c26.png";